import { Permission } from '~/types/Permission';
import { User } from '~/types/User';

// Note: this logic is modelled on a custom field on the User that is not role-based or feature-flag-based
export const checkIsAutomationAdmin: Permission = (user: User) => {
  return user.is_automation_admin;
};
